import React from 'react';
import styled from 'styled-components';
import { Paragraph } from '../../../../../styledComponents/styles/Paragraph.styled';
import {} from '../../../../../shared/helpers/General';
import { EmbedVideoOnPreview } from '../../../../../components/pages/TravelerApplication/TravelerApplicationForm/EmbedVideoOnPreview';

const Container = styled.div`
  font-family: 'Nunito', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 0.015em;
  color: #373737;
`;

const InputContainer = styled.div`
  flex: 1;
  margin: 13px 0;
  text-align: left;
`;

const Label = styled.div`
  color: ${({ theme }) => theme.textInput.label.fontColor};
  font-family: ${({ theme }) => theme.textInput.label.fontFamily};
  font-size: ${({ theme }) => theme.textInput.label.fontSize};
  font-weight: ${({ theme }) => theme.textInput.label.fontWeight};
`;

const Required = styled.span`
  color: ${({ theme }) => theme.defaults.errorColor};
  padding-left: 5px;
`;
const QuestionVideoPromptDisplayPreview = ({ question }) => {
  const updatedInstruction = !!question.instructions ? question.instructions.replace(/<p><\/p>/g, '<br />') : '';
  return (
    <Container>
      <InputContainer>
        <Label tabIndex={0}>
          {question.label}
          {question.required && <Required>*</Required>}
        </Label>
        <Paragraph
          tabIndex={1}
          id='video-prompt-instructions'
          openSans
          dangerouslySetInnerHTML={{
            __html: updatedInstruction,
          }}
        />
        <div>{EmbedVideoOnPreview('', question.url, '', '100%')}</div>
      </InputContainer>
    </Container>
  );
}

export default QuestionVideoPromptDisplayPreview;

